
const PdpEntrySsr = () => import(/* webpackChunkName: "pdpEntrySsr" */ './PdpEntrySsr');

export default [
  {
    path: '/product/:urlKey',
    name: 'pdpPage',
    component: PdpEntrySsr,
    meta: {
      noScroll: true
    },
    props: true,
  },
];
